import lightMode, { colorScaleLight } from './lightMode';
export const colorScaleCloudLight = colorScaleLight;

const lightCloudMode: typeof lightMode = () => ({
  ...lightMode(),
  CONTROL_UNIT_DETAILS_BACKGROUND_COLOR: 'rgb(255, 255, 255)',
  CONTROL_UNIT_DETAILS_CHART_BACKGROUND_COLOR_ACCENT: 'rgb(230, 230, 230)',
});

export default lightCloudMode;
